// extracted by mini-css-extract-plugin
module.exports = {"root":"Button-module--root--32E30","dark":"Button-module--dark--1OXNP"};